export const DEPOSIT_WITHIN_HOURS: number = 1
export const REQUIRED_INVOICE_USD_AMOUNT: number = 25000
export const EUROPE_COUNTRIES = ['NL', 'DK', 'DE', 'LV', 'LU', 'LT', 'MC', 'MT', 'BE', 'BG', 'CY', 'SE', 'ES', 'IE', 'EE', 'AT', 'IT', 'PT', 'PL', 'FR', 'FI', 'CZ']
